import { Link } from 'react-router-dom';
import { Logo } from '@/components/brand/Logo';
import { VisitorOnly } from '@/hooks/useIsVisitor';

const COLS = [
  { title: 'Plataforma', links: [['Sobre a plataforma', '/sobre'], ['Como funciona', '/como-funciona'], ['Categorias', '/categorias'], ['Comunidade', '/comunidade']] },
  { title: 'Explorar', links: [['Empresas', '/empresas'], ['Oportunidades', '/oportunidades'], ['Cadastrar empresa', '/cadastrar-empresa'], ['Informações sobre publicidade', '/publicidade']] },
  { title: 'Institucional', links: [['Termos de uso', '/termos'], ['Política de privacidade', '/privacidade'], ['Diretrizes da comunidade', '/diretrizes'], ['Contato', '/contato']] },
];

export const Footer = () => (
  <footer className="mt-20 border-t border-white/10 bg-[#06070a]" data-testid="site-footer">
    <div className="container-x grid gap-10 py-14 md:grid-cols-[1.4fr_repeat(3,1fr)]">
      <div>
        <Logo />
        <p className="mt-4 max-w-sm text-sm leading-relaxed text-muted-foreground">
          Rede nacional de empresas e empreendedores que valorizam a livre iniciativa, a liberdade econômica e o trabalho.
        </p>
        <VisitorOnly>
          <p className="mt-4 max-w-sm rounded-md border border-white/10 bg-white/[0.03] px-3 py-2 text-xs text-muted-foreground">
            Protótipo de demonstração. Empresas, oportunidades e indicadores exibidos são fictícios. Dados criados ficam salvos apenas neste navegador.
          </p>
        </VisitorOnly>
      </div>
      {COLS.map((c) => (
        <div key={c.title}>
          <div className="eyebrow mb-4 text-muted-foreground">{c.title}</div>
          <ul className="space-y-2.5">
            {c.links.map(([label, to]) => (
              <li key={to}>
                <Link to={to} className="text-sm text-muted-foreground transition-colors hover:text-foreground" data-testid={`footer-link-${to.slice(1)}`}>{label}</Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
    <div className="border-t border-white/5">
      <div className="container-x flex flex-col gap-3 py-5 text-xs text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
        <span>
          © {new Date().getFullYear()} Brasil Livre Business
          <VisitorOnly> · nome provisório · versão de demonstração</VisitorOnly>
        </span>
        <div className="flex items-center gap-4">
          <Link to="/admin" className="text-muted-foreground/60 transition-colors hover:text-foreground" data-testid="footer-admin-link">Administração</Link>
        </div>
      </div>
    </div>
  </footer>
);